import * as React from 'react'

function SvgModel3d(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="1.47em" height="1.47em" viewBox="0 0 22 22" fill="none" {...props}>
            <g transform="scale(1.4)">
                <rect x="2" y="2" width="18" height="18" rx="4" fill="currentColor"   opacity="0.15"/>
                <g transform='translate(-5,0)'>
                    {/* Cube shape */}
                    <polygon points="11,6 16,9 16,15 11,18 6,15 6,9" fill="currentColor" stroke='grey' opacity="0.35"/>
                    <polygon points="11,6 16,9 11,12 6,9" fill="currentColor" opacity="0.55"/>
                    <polygon points="11,12 16,9 16,15 11,18" fill="currentColor" opacity="0.45"/>
                    <polygon points="11,12 6,9 6,15 11,18" fill="currentColor" opacity="0.65"/>
                    <polyline points="11,6 11,12 11,18" stroke="currentColor" strokeWidth="0.5" opacity="0.7" fill="none"/>
                </g>
            </g>
            <text
                x="11"
                y="15"
                textAnchor="middle"
                fontFamily="Arial, Helvetica, sans-serif"
                fontWeight="bold"
                fontSize="8"
                fill="currentColor"
            >
                3D
            </text>
        </svg>
	)
}

export default SvgModel3d
